export default "__VITE_ASSET__CMnI0i0n__"